export const FETCH_MATERIAL_LIST = '@@maintenance/fetch-material-list';
export const FETCH_MATERIAL_LIST_SUCCESS = '@@maintenance/fetch-material-list-success';
export const FETCH_MATERIAL_LIST_FAILURE = '@@maintenance/fetch-material-list-failure';
